import classNames from "classnames";
import ByAQIProgress from "./ByAQIProgress";
import { homeAtom } from "@/atoms/home";
const ChartData: React.FC<any> = ({ aqi = undefined }: any) => {
  const homeData = useAtomValue(homeAtom);
  aqi = (aqi || homeData?.data?.["aqi"]) ?? {};
  return (
    <>
      <WeatherContent
        className={classNames([
          "w-full flex flex-col justify-start items-stretch gap-y-16 rounded-10  backdrop-blur-10 p-16 bg-[var(--app-bg-08)]",
        ])}
      >
        <ByAQIProgress aqi={aqi} />
      </WeatherContent>
    </>
  );
};
export default ChartData;
